import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { CategoryService } from 'app/core/category/category.service';
import { InitialData } from 'app/modules/admin/manage-subcategory/subcategory.types';

@Injectable({
    providedIn: 'root'
})
export class SubcategoryDataResolver implements Resolve<any>
{
    /**
     * Constructor
     */
    constructor(private _httpClient: HttpClient, private _categoryService: CategoryService) {
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<InitialData> {
        return this._categoryService.getSubCategories(route.params['id'])
        .pipe(
            map((subCategories) => ({
                subCategories
            })
            ),
            catchError(err => {
                this._categoryService.errorMessage = err.error.message ? err.error.message : "Something went wrong !";
                return of(new DefaultResponse().subCategories);
            })
        );
        
    }

}
class DefaultResponse implements InitialData {
    subCategories: any = [];
}